module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-FC-Pet.80e52043.gif";